import { hotSearch } from "@/mocks/gossip";

const footCols = [
  {
    title: "追瓜栏目",
    links: [
      { label: "今日热榜", href: "#hot" },
      { label: "明星八卦", href: "#star" },
      { label: "网红主播", href: "#streamer" },
      { label: "实锤档案", href: "#impact" },
      { label: "最新动态", href: "#news" },
    ],
  },
  {
    title: "追瓜指南",
    links: [
      { label: "理性吃瓜三步", href: "#guide" },
      { label: "常见问题", href: "#faq" },
      { label: "瓜友怎么说", href: "#guide" },
      { label: "订阅快讯", href: "#join" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50/85">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          {/* brand + about */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="font-heading grid h-10 w-10 place-items-center rounded-xl bg-accent-500 text-primary-950">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-background-50">刚刚爆料</span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-7 text-background-50/70">
              「刚刚爆料」是一个开放、轻松的追瓜平台，专注明星网红主播、网红主播与娱乐圈公众人物的动态，用标注清晰的方式呈现八卦的冷暖、翻车与实锤，陪你在饭后愉快吃瓜。
            </p>
            <p className="mt-4 text-xs leading-6 text-background-50/50">
              本站仅聚合与转述已公开信息，对未经证实的传闻均标注“待实锤”，不代表平台立场，也不对任何当事人作价值判断。
            </p>
          </div>

          {/* nav columns */}
          {footCols.map((col) => (
            <nav key={col.title} className="md:col-span-2">
              <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-background-50/65 transition hover:text-accent-300">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* contact */}
          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">联系与纠错</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-50/65">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-300" />
                <a href="mailto:hello@gang-gua.top" className="transition hover:text-accent-300">
                  hello@gang-gua.top
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-edit-line text-accent-300" />
                发现信息有误，欢迎来信核实
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-cup-line text-accent-300" />
                合作洽谈：广告位与栏目共建
              </li>
            </ul>
          </div>
        </div>

        {/* tag cloud */}
        <div className="mt-10 border-t border-background-50/10 pt-6">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-background-50/50">热门追瓜：</span>
            {hotSearch.slice(0, 8).map((h) => (
              <a
                key={h.word}
                href="#news"
                className="rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-50/70 transition hover:bg-background-50/20 hover:text-background-50"
              >
                {h.word}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-50/50">
            © 2026 刚刚爆料 · 饭后追瓜，看这一页就够了
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-background-50/45">
            <span>理性吃瓜</span>
            <span>不信谣不传谣</span>
            <span>尊重原创</span>
          </p>
        </div>
      </div>
    </footer>
  );
}